export default function XRHeadset({ tilt = 3, size = "160px" }) {
  return (
    <div
      className="motif-xr-headset"
      style={{ transform: `rotate(${tilt}deg)` }}
    >
      <div
        className="motif-xr-visor"
        style={{
          width: size,
          height: `calc(${size} * 0.67)`,
        }}
      ></div>
      <div
        className="motif-xr-strap"
        style={{
          width: `calc(${size} * 1.1)`,
        }}
      ></div>
    </div>
  );
}
